import React from "react";
import { TS } from "~/Services/TS";

export function GenerateTranslationsProgressBar({ isChoosingLanguage }: { isChoosingLanguage: boolean }) {
    return (
        <section className="step-wizard">
            <ul className="step-wizard-list">
                <li className="step-wizard-item">
                    <span className="progress-count"></span>
                    <span className="progress-label">{TS("Choose Languages")}</span>
                </li>
                <li className={`step-wizard-item ${!isChoosingLanguage && "current-item"}`}>
                    <span className="progress-count"></span>
                    <span className="progress-label">{TS("Edit Translation")}</span>
                </li>
            </ul>
        </section>
    );
}
